sew-ws-image-text-float {
    display: block;

    &:not([no-grid]) {
        @include grid;
    }

    &:not([no-margin]) {
        @include component-spacing;
    }

    .main-content-container {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: min-content 1fr;
        column-gap: var(--column-gap);
    }

    .headline {
        @include typo-ws-h2;

        grid-area: 1 / 1 / 2 / 9;
        margin: 0 0 16px;
    }

    sew-ws-richtext {
        grid-area: 2 / 1 / 3 / 9;
    }

    sew-picture {
        grid-area: 1 / 9 / 3 / 13;
    }

    &[reverse] {
        .headline {
            grid-area: 1 / 4 / 2 / 13;
        }
        sew-ws-richtext {
            grid-area: 2 / 4 / 3 / 13;
        }
        sew-picture {
            grid-area: 1 / 1 / 3 / 4;
        }
    }
}

@include mq-1 {
    sew-ws-image-text-float {
        .main-content-container {
            display: block;
        }
        sew-picture {
            float: right;
            width: 33%;
            margin: 0 0 var(--column-gap) var(--column-gap);
        }
        &.reverse {
            sew-picture {
                float: left;
                margin: 0 var(--column-gap) var(--column-gap) 0;
            }
        }
    }
}
